import { lazy } from 'react';

// Lazy load service area components to reduce initial bundle size
export const MarsdenPark = lazy(() => import("@/pages/service-areas/MarsdenPark"));
export const Blacktown = lazy(() => import("@/pages/service-areas/Blacktown"));
export const CastleHill = lazy(() => import("@/pages/service-areas/CastleHill"));
export const Liverpool = lazy(() => import("@/pages/service-areas/Liverpool"));
export const Hurstville = lazy(() => import("@/pages/service-areas/Hurstville"));
export const Newtown = lazy(() => import("@/pages/service-areas/Newtown"));
export const SevenHills = lazy(() => import("@/pages/service-areas/SevenHills"));
export const Penrith = lazy(() => import("@/pages/service-areas/Penrith"));
export const StMarys = lazy(() => import("@/pages/service-areas/StMarys"));
export const Doonside = lazy(() => import("@/pages/service-areas/Doonside"));
export const RootyHill = lazy(() => import("@/pages/service-areas/RootyHill"));
export const MountDruitt = lazy(() => import("@/pages/service-areas/MountDruitt"));
export const Granville = lazy(() => import("@/pages/service-areas/Granville"));
export const Ryde = lazy(() => import("@/pages/service-areas/Ryde"));
export const BaulkhamHills = lazy(() => import("@/pages/service-areas/BaulkhamHills"));
export const Bankstown = lazy(() => import("@/pages/service-areas/Bankstown"));
export const Merrylands = lazy(() => import("@/pages/service-areas/Merrylands"));
export const Chatswood = lazy(() => import("@/pages/service-areas/Chatswood"));
export const Campbelltown = lazy(() => import("@/pages/service-areas/Campbelltown"));
export const Epping = lazy(() => import("@/pages/service-areas/Epping"));
export const Marrickville = lazy(() => import("@/pages/service-areas/Marrickville"));
export const QuakersHill = lazy(() => import("@/pages/service-areas/QuakersHill"));
export const Guildford = lazy(() => import("@/pages/service-areas/Guildford"));
export const Auburn = lazy(() => import("@/pages/service-areas/Auburn"));
export const Lidcombe = lazy(() => import("@/pages/service-areas/Lidcombe"));
export const Carlingford = lazy(() => import("@/pages/service-areas/Carlingford"));
export const Revesby = lazy(() => import("@/pages/service-areas/Revesby"));
export const Padstow = lazy(() => import("@/pages/service-areas/Padstow"));
export const Panania = lazy(() => import("@/pages/service-areas/Panania"));
export const Hornsby = lazy(() => import("@/pages/service-areas/Hornsby"));
export const DeeWhy = lazy(() => import("@/pages/service-areas/DeeWhy"));
export const StIves = lazy(() => import("@/pages/service-areas/StIves"));
export const MacquariePark = lazy(() => import("@/pages/service-areas/MacquariePark"));
export const FrenchsForest = lazy(() => import("@/pages/service-areas/FrenchsForest"));
export const Cherrybrook = lazy(() => import("@/pages/service-areas/Cherrybrook"));
export const Casula = lazy(() => import("@/pages/service-areas/Casula"));
export const Fairfield = lazy(() => import("@/pages/service-areas/Fairfield"));

export const Sutherland = lazy(() => import("@/pages/service-areas/Sutherland"));
export const Strathfield = lazy(() => import("@/pages/service-areas/Strathfield"));
export const Kogarah = lazy(() => import("@/pages/service-areas/Kogarah"));
export const Ashfield = lazy(() => import("@/pages/service-areas/Ashfield"));
export const Randwick = lazy(() => import("@/pages/service-areas/Randwick"));
export const Bondi = lazy(() => import("@/pages/service-areas/Bondi"));
export const Eastwood = lazy(() => import("@/pages/service-areas/Eastwood"));
export const Leichhardt = lazy(() => import("@/pages/service-areas/Leichhardt"));
export const StanhopeGardens = lazy(() => import("@/pages/service-areas/StanhopeGardens"));
export const Kellyville = lazy(() => import("@/pages/service-areas/Kellyville"));
export const Norwest = lazy(() => import("@/pages/service-areas/Norwest"));
export const EmuPlains = lazy(() => import("@/pages/service-areas/EmuPlains"));
export const Schofields = lazy(() => import("@/pages/service-areas/Schofields"));
export const BoxHill = lazy(() => import("@/pages/service-areas/BoxHill"));
export const Clayton = lazy(() => import("@/pages/service-areas/Clayton"));
export const Oakleigh = lazy(() => import("@/pages/service-areas/Oakleigh"));
export const Springvale = lazy(() => import("@/pages/service-areas/Springvale"));
export const Cheltenham = lazy(() => import("@/pages/service-areas/Cheltenham"));
export const Glenwood = lazy(() => import("@/pages/service-areas/Glenwood"));
export const Zetland = lazy(() => import("@/pages/service-areas/Zetland"));
export const Cronulla = lazy(() => import("@/pages/service-areas/Cronulla"));
export const Miranda = lazy(() => import("@/pages/service-areas/Miranda"));
export const SouthCaringbah = lazy(() => import("@/pages/service-areas/SouthCaringbah"));
export const Bexley = lazy(() => import("@/pages/service-areas/Bexley"));
export const Menai = lazy(() => import("@/pages/service-areas/Menai"));
export const Wollongong = lazy(() => import("@/pages/service-areas/Wollongong"));
export const Rockdale = lazy(() => import("@/pages/service-areas/Rockdale"));
export const Manly = lazy(() => import("@/pages/service-areas/Manly"));
export const MonaVale = lazy(() => import("@/pages/service-areas/MonaVale"));
export const Paddington = lazy(() => import("@/pages/service-areas/Paddington"));
export const EastLakes = lazy(() => import("@/pages/service-areas/EastLakes"));
export const Mascot = lazy(() => import("@/pages/service-areas/Mascot"));
export const Pagewood = lazy(() => import("@/pages/service-areas/Pagewood"));
export const Prestons = lazy(() => import("@/pages/service-areas/Prestons"));
export const Ingleburn = lazy(() => import("@/pages/service-areas/Ingleburn"));
export const Campsie = lazy(() => import("@/pages/service-areas/Campsie"));
export const Minto = lazy(() => import("@/pages/service-areas/Minto"));
export const OranPark = lazy(() => import("@/pages/service-areas/OranPark"));
export const GregoryHills = lazy(() => import("@/pages/service-areas/GregoryHills"));
export const Narellan = lazy(() => import("@/pages/service-areas/Narellan"));
export const Punchbowl = lazy(() => import("@/pages/service-areas/Punchbowl"));
export const Dural = lazy(() => import("@/pages/service-areas/Dural"));
export const WestPennantHills = lazy(() => import("@/pages/service-areas/WestPennantHills"));
export const HoppersCrossing = lazy(() => import("@/pages/service-areas/HoppersCrossing"));
export const PointCook = lazy(() => import("@/pages/service-areas/PointCook"));
export const Craigieburn = lazy(() => import("@/pages/service-areas/Craigieburn"));
export const Pakenham = lazy(() => import("@/pages/service-areas/Pakenham"));
export const Frankston = lazy(() => import("@/pages/service-areas/Frankston"));
export const Dandenong = lazy(() => import("@/pages/service-areas/Dandenong"));
export const Sunbury = lazy(() => import("@/pages/service-areas/Sunbury"));
export const Geelong = lazy(() => import("@/pages/service-areas/Geelong"));
export const Ballarat = lazy(() => import("@/pages/service-areas/Ballarat"));
export const Bendigo = lazy(() => import("@/pages/service-areas/Bendigo"));
export const Mornington = lazy(() => import("@/pages/service-areas/Mornington"));
export const MountEliza = lazy(() => import("@/pages/service-areas/MountEliza"));
export const Doncaster = lazy(() => import("@/pages/service-areas/Doncaster"));
export const Templestowe = lazy(() => import("@/pages/service-areas/Templestowe"));
export const Ringwood = lazy(() => import("@/pages/service-areas/Ringwood"));
export const Berwick = lazy(() => import("@/pages/service-areas/Berwick"));
export const NarreWarren = lazy(() => import("@/pages/service-areas/NarreWarren"));
export const Preston = lazy(() => import("@/pages/service-areas/Preston"));
export const Footscray = lazy(() => import("@/pages/service-areas/Footscray"));
export const Heidelberg = lazy(() => import("@/pages/service-areas/Heidelberg"));
export const GlenWaverley = lazy(() => import("@/pages/service-areas/GlenWaverley"));
export const Chadstone = lazy(() => import("@/pages/service-areas/Chadstone"));

export const TarneitServiceArea = lazy(() => import("@/pages/service-areas/Tarneit"));